import type { ProviderKey, SourceKey } from './types';

/**
 * Toolbar filter chips + month-cell brand badge row. Keys are SourceKey
 * (per-brand).
 */
export const SOURCE_LOGO: Record<SourceKey, { light: string; dark: string }> = {
  garmin:    { light: '/logos/garmin/garmin-connect-icon.png',
               dark:  '/logos/garmin/garmin-connect-icon.png' },
  whoop:     { light: '/logos/whoop/Logo/Circle/WHOOP Circle Black.svg',
               dark:  '/logos/whoop/Logo/Circle/WHOOP Circle White.svg' },
  catapult:  { light: '/logos/catapult/catapult-icon-black.webp',
               dark:  '/logos/catapult/catapult-icon-white.webp' },
  hawkin:    { light: '/logos/hawkin/hawkin-icon-black.webp',
               dark:  '/logos/hawkin/hawkin-icon-white.webp' },
  coros:     { light: '/logos/coros/coros-logo.png',
               dark:  '/logos/coros/coros-logo.png' },
  suunto:    { light: '/logos/suunto/suunto-logo.png',
               dark:  '/logos/suunto/suunto-logo.png' },
  oura:      { light: '/logos/oura/oura-logo.png',
               dark:  '/logos/oura/oura-logo.png' },
};

/**
 * Per-row brand stamp on week-view + DayPanel activity tiles.
 * Keys are ProviderKey. Polar asset is missing in /static/logos/ —
 * consumer falls back to a text badge rendered in the component.
 */
export const PROVIDER_LOGO: Record<ProviderKey, { light: string; dark: string } | null> = {
  garmin:    { light: '/logos/garmin/garmin-connect-icon.png',
               dark:  '/logos/garmin/garmin-connect-icon.png' },
  whoop:     { light: '/logos/whoop/Logo/Circle/WHOOP Circle Black.svg',
               dark:  '/logos/whoop/Logo/Circle/WHOOP Circle White.svg' },
  catapult:  { light: '/logos/catapult/catapult-icon-black.webp',
               dark:  '/logos/catapult/catapult-icon-white.webp' },
  hawkin:    { light: '/logos/hawkin/hawkin-icon-black.webp',
               dark:  '/logos/hawkin/hawkin-icon-white.webp' },
  coros:     { light: '/logos/coros/coros-logo.png',
               dark:  '/logos/coros/coros-logo.png' },
  suunto:    { light: '/logos/suunto/suunto-logo.png',
               dark:  '/logos/suunto/suunto-logo.png' },
  oura:      { light: '/logos/oura/oura-logo.png',
               dark:  '/logos/oura/oura-logo.png' },
  'cgm-model': null,
};

export const CHANNEL_ACCENT: Record<'training' | 'assessment' | 'recovery', string> = {
  training:   'var(--channel-training)',
  assessment: 'var(--channel-assessment)',
  recovery:   'var(--channel-recovery)',
};
